import List from "./List";
import Edit from "./Edit";
import Create from "./Create";

export const RecordingList = List;
export const RecordingEdit = Edit;
export const RecordingCreate = Create;
